import { Dialog, DialogContent, Typography, Button, DialogTitle, Divider, DialogActions } from "@mui/material";
import useAuth from 'hooks/useAuth';
import { useSessionExpire } from "./SessionExpireContext";

export default function SessionExpireModal({ open }) {

    const { logout } = useAuth();
     const { hideSessionExpirePopup } = useSessionExpire();

    const handleLogout = async () => {
        try {
            hideSessionExpirePopup(); 
            await logout();
            navigate(`/login`, {
                state: {
                    from: ''
                }
            });
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <Dialog open={open} onClose={(e) => e.stopPropagation()}
            fullWidth maxWidth="xs">
            <DialogTitle>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <span>Logout</span>
                </div>
            </DialogTitle>

            <Divider sx={{ border: '0.5px solid #eeebeb' }} />

            <DialogContent sx={{ textAlign: 'center', py: 4 }}>
                <div style={{ fontSize: 14, marginTop: 8 }}>
                    Your session has expired because you logged in from another tab or device.
                </div>
            </DialogContent>

            <Divider sx={{ border: '0.5px solid #eeebeb' }} />

            <DialogActions>
                <Button variant="contained" color="error" onClick={handleLogout}>Logout</Button>
            </DialogActions>
        </Dialog>
    );
}
